import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import './AboutUs.css';
import axios from 'axios';

const AboutUs = () => {
  const [metaTags, setMetaTags] = useState([]);

  useEffect(() => {
    document.title = "About Us - Funfillia";

    const fetchMetaTags = async () => {
      try {
        const res = await axios.get('https://api.funfillia.com/api/v2/website/metaTags/about_us', {
          headers: {
            Accept: 'application/json',
            'Client-Domain':'www.funfillia.com',
          },
        });

        const htmlString = res.data?.metaTags || '';
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        const tags = Array.from(doc.head.children);
        setMetaTags(tags);
      } catch (err) {
        console.error("Error fetching meta tags for About Us:", err);
      }
    };

    fetchMetaTags();
  }, []);

  const getMetaContent = (attr, value) => {
    const tag = metaTags.find(t => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  return (
    <>
      <Helmet>
        <title>About Us - Funfillia</title>

        {/* General */}
        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description')} />
        <meta name="keywords" content={getMetaContent('name', 'keywords')} />
        <link rel="canonical" href={window.location.href} />

        {/* Open Graph */}
        <meta property="og:type" content={getMetaContent('property', 'og:type')} />
        <meta property="og:url" content={getMetaContent('property', 'og:url')} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />

        {/* Twitter */}
        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
        <meta name="twitter:url" content={getMetaContent('name', 'twitter:url')} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
      </Helmet>

      <div className="about-container">
        <div className="about-box">
          <h1>About Funfillia</h1>
          <p>
            Welcome to <strong>Funfillia</strong> – the happiest place on the internet! We’re a blogging site dedicated
            to spreading laughter, joy, and interactive fun across the globe. Whether you’re here to watch something funny, 
            play a game, or discover something new and exciting, Funfillia is your perfect online escape.
          </p>

          <h2>What We Offer</h2>
          <p>Our content is carefully crafted and curated to keep you smiling, engaged, and entertained. We cover:</p>

          <ul>
            <li><strong>Entertainment & Humor:</strong> From hilarious memes to celebrity gossip, pranks, reactions, and more.</li>
            <li><strong>Games & Interactive Fun:</strong> Dive into quizzes, mini-games, puzzles, and challenges for all ages.</li>
            <li><strong>Lifestyle & Creativity:</strong> Watch DIY crafts, food experiments, pet antics, and cool tech toys in action.</li>
            <li><strong>Global Fun & Community:</strong> Discover fun facts, travel twists, and laugh-out-loud stories from around the world.</li>
          </ul>

          <h2>Why Funfillia?</h2>
          <p>
            Because we believe that fun and happiness should be part of your daily scroll. In a world full of stress and seriousness,
            Funfillia brings back the magic of joy, imagination, and shared laughter.
          </p>

          <h2>Join the Fun</h2>
          <p>
            Explore. Laugh. Play. Share. Whether you’re a meme lover, trivia master, or curious explorer, there’s something for everyone at Funfillia.
          </p>

          <p className="closing-text">
            ❤️ Stay happy, stay fun. With love, <br />
            The <strong>Funfillia</strong> Team
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
